import React from 'react';
import {useField} from 'formik';

import ButtonGroupRadios from 'shared/portfolio/components/courses/button-group-radios';

interface Props {
  closePopover: () => void;
}

const options = [
  {value: 'W', display: <span>Withdraw</span>},
  {value: 'I', display: <span>Incomplete</span>},
];

const MoreGradePicker = ({closePopover}: Props) => {
  const [, , gradeTypeHelpers] = useField('grade.gradeType');

  return (
    <div className="course-more-grade-picker">
      <ButtonGroupRadios
        options={options}
        name="gradeInputPicker"
        onChange={() => {
          gradeTypeHelpers.setValue('M');
          closePopover();
        }}
      />
    </div>
  );
};

export default MoreGradePicker;
